import React from 'react';
import '../styles/BuyersFilterModal.css';
import { FilterChip } from '../components';

function BuyersFilterModal(props) {
    const activeFilter = props.activeFilter || 'all';
    const setActiveFilter = props.setActiveFilter;

    return (
        <div className="buyers-filter-modal-body">
            <div className="buyers-filter-section">
                <span className="body-bold colour-primary buyers-filter-section-label">
                    Status
                </span>
                <div className="buyers-filter-chip-row">
                    <FilterChip
                        label="All"
                        selected={activeFilter === 'all'}
                        index="all"
                        disabled={false}
                        func={() => setActiveFilter && setActiveFilter('all')}
                        leftIcon={null}
                        rightIcon={null}
                    />
                    <FilterChip
                        label="Active only"
                        selected={activeFilter === 'active'}
                        index="active"
                        disabled={false}
                        func={() => setActiveFilter && setActiveFilter('active')}
                        leftIcon={null}
                        rightIcon={null}
                    />
                    <FilterChip
                        label="Inactive only"
                        selected={activeFilter === 'inactive'}
                        index="inactive"
                        disabled={false}
                        func={() => setActiveFilter && setActiveFilter('inactive')}
                        leftIcon={null}
                        rightIcon={null}
                    />
                </div>
            </div>
        </div>
    );
}

export default BuyersFilterModal;
